import { render, staticRenderFns } from "./ServerOffline.vue?vue&type=template&id=b6844ec8&scoped=true&"
import script from "./ServerOffline.vue?vue&type=script&lang=js&"
export * from "./ServerOffline.vue?vue&type=script&lang=js&"
import style0 from "./ServerOffline.vue?vue&type=style&index=0&id=b6844ec8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6844ec8",
  null
  
)

export default component.exports